import { configureStore } from "@reduxjs/toolkit"
import authReducer from "./store/reducer/authReducer"
import drawerReducer from "./store/reducer/drawerReducer"
import userReducer from "./store/reducer/userReducer"
import loaderReducer from "./store/reducer/loaderReducer"
import toastReducer from "./store/reducer/toastReducer"
// ...

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    drawer: drawerReducer,
    loader: loaderReducer,
    toast: toastReducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
